import io from "socket.io-client";

export default class WebsocketChat {
  #websocketServeUrl;
  connected = false;
  socket;

  constructor() {
    this.#websocketServeUrl = process.env.VUE_APP_CHAT_URL;
  }

  connect() {
    if (this.connected) {
      return this.socket;
    }
    this.socket = io.connect(this.#websocketServeUrl);
    this.connected = true;

    return this.socket;
  }
}